import * as React from "react";
import { UitkSelect } from "uitk-react-select";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { observer } from "mobx-react";
import { CarTypeInformation } from "src/stores/wizard/config/staticConfigs/car/typings";
import { formatText } from "bernie-l10n/dist/localization";
import { locKeys } from "../l10n";
import { CarTypeDropdownProps } from "../../typings";

export const CarTypeDropdown = observer(({ carWizardState, colSpan }: CarTypeDropdownProps) => {
  const carFromConfig: CarTypeInformation[] = carWizardState.config.cars;
  const cars: CarTypeInformation[] = Object.values(carFromConfig).filter(
    ({ includeInDropdown }: CarTypeInformation) => includeInDropdown
  );
  const { carType } = carWizardState;

  const onCarTypeSelectChange = (selectEvent: React.ChangeEvent<HTMLSelectElement>) => {
    carWizardState.carType = selectEvent.currentTarget.value;
  };
  const searchValue: CarTypeInformation[] = Object.values(carFromConfig).filter(
    ({ locKey }: CarTypeInformation) => formatText(locKey) === carType
  );
  const searchKey = searchValue[0]
    ? `["${searchValue[0].carCode.toLowerCase()}"]`
    : `["${cars[0].carCode.toLowerCase()}"]`;

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <div>
        <UitkSelect
          id="carType"
          label={formatText(locKeys.carType)}
          onChange={onCarTypeSelectChange}
          value={carType}
          data-testid="car-type-list"
        >
          {cars.map(({ carCode, locKey }) => (
            <option key={carCode} value={carCode}>
              {formatText(locKey)}
            </option>
          ))}
        </UitkSelect>
        <input type="hidden" name="selCC" value={searchKey} />
      </div>
    </UitkLayoutGridItem>
  );
});
